<template>
  <li
    :class="{'is-active': tabTitle === removeDash}"
    @click="switchActiveTab()"
  >
    <a>
      {{ toUpperCase }}
    </a>
  </li>
</template>

<script>
export default {
  name: '',
  props: ['tabTitle', 'activeTab'],
  data () {
    return {}
  },
  computed: {
    toUpperCase () {
      return this.tabTitle.toUpperCase()
    },
    removeDash () {
      return this.activeTab.split('-').join(' ')
    }
  },
  methods: {
    switchActiveTab () {
      // Add dash to whitespaces
      let tab = this.tabTitle.split(' ').join('-')
      this.$emit('switchActiveTab', tab)
    }
  }
}
</script>